import { ReactNode, useState } from 'react';
import { InputLabel } from './InputLabel';
import { BlockPicker } from 'react-color';
import { BlockPickerStylesProps } from 'react-color/lib/components/block/Block';
import reactCSS, { Classes } from 'reactcss';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faEyeDropper } from '@fortawesome/pro-solid-svg-icons';

const DEFAULT_COLORS = [
  '#6367EF',
  '#7C7FD8',
  '#B390CF',
  '#BF6502',
  '#D4832A',
  '#F8B24C',
  '#5F5041',
  '#8D7862',
  '#C7A887',
  '#D85265',
  '#DB7D8B',
  '#DE919D',
  '#904D3D',
  '#A66B5D',
  '#C19085',
  '#57773A',
  '#6C8650',
  '#90A064',
  '#378582',
  '#63A9A2',
  '#79BAAE',
  '#3C6799',
  '#5F91C9',
  '#8ABBEC',
  '#43924A',
  '#66B16D',
  '#88CC8E',
  '#455057',
  '#6D7479',
  '#9CA1A5',
];

export const ColorPicker = ({
  value,
  onChange,
  label,
  showColorBox,
  colors = DEFAULT_COLORS,
}: {
  value: string;
  onChange: (val: string) => any;
  label?: ReactNode;
  showColorBox?: boolean;
  colors?: string[];
}) => {
  const [open, setOpen] = useState(false);

  const colorPickerStyles: Partial<Classes<BlockPickerStylesProps>> = reactCSS({
    default: {
      default: {
        card: {
          width: '330px',
          border: '1px solid black',
        },
        body: {
          width: '330px',
        },
        input: {
          height: '40px',
          fontSize: '20px',
          color: 'black',
        },
        head: {
          height: '50px',
        },
      },
    },
  });

  return (
    <div className="relative">
      <InputLabel {...{ label }} />

      <div className="flex">
        {showColorBox ? (
          <div
            className="mr-2.5 w-[44px] h-[44px] rounded-lg flex items-center justify-center"
            style={{ backgroundColor: value }}
            onClick={() => setOpen(true)}
          >
            <Icon icon={faEyeDropper} color="white" />
          </div>
        ) : null}
        <div
          data-testid="color-picker"
          className="flex-grow relative border-2 border-[#DAE1ED] bg-[#FAFCFD] px-4 pt-[8px] pb-[8px] rounded-lg focus-within:border-primary transition-colors cursor-pointer"
          onClick={() => setOpen((x) => !x)}
        >
          {value}
        </div>
      </div>

      {open ? (
        <div className="absolute top-full w-full mt-2 z-[1]">
          <BlockPicker
            styles={colorPickerStyles}
            className="mb-7"
            onChange={(val) => {
              onChange(val.hex);
            }}
            onChangeComplete={() => {
              setOpen(false);
            }}
            colors={colors}
            color={value}
          />
        </div>
      ) : null}
    </div>
  );
};
